import {
  DocumentReference,
  getFirestore,
  doc,
  getDoc,
} from 'firebase/firestore'
import { useEffect, useState } from 'react'

import useHandleError from '../../../../hooks/useHandleError'
import FirestoreUser from '../../../../types/FirestoreUser'
import { primaryServices } from '../../../../utils/firebaseServiceContext'

interface UseCurrentAdminProfileReturn {
  adminProfile: FirestoreUser['profile'] | null
  adminName: string
  adminInitials: string
}

export function useCurrentAdminProfile(): UseCurrentAdminProfileReturn {
  const [adminProfile, setAdminProfile] = useState<
    FirestoreUser['profile'] | null
  >(null)
  const handleError = useHandleError()

  useEffect(() => {
    async function fetchCurrentUserProfile() {
      const currentUser = primaryServices.auth.currentUser
      if (currentUser) {
        const currentUserRef = doc(
          primaryServices.firestore,
          'users',
          currentUser.uid
        ) as DocumentReference<FirestoreUser>
        const currentUserSnap = await getDoc(currentUserRef)
        const currentUserData = currentUserSnap.data()
        if (currentUserData?.profile) {
          setAdminProfile(currentUserData.profile)
        }
      }
    }

    fetchCurrentUserProfile().catch(handleError)
  }, [handleError])

  const adminName = adminProfile
    ? `${adminProfile.firstName || ''} ${adminProfile.lastName || ''}`.trim()
    : 'Unknown Admin'

  const adminInitials = adminProfile
    ? `${adminProfile.firstName?.[0] || ''}${
        adminProfile.lastName?.[0] || ''
      }`.toUpperCase()
    : ''

  return {
    adminProfile,
    adminName,
    adminInitials,
  }
}
